'use strict';

angular.module('far.models.mountains.mountains', [])
.service('mountains', function($log, $http) {
	var list = [],
		firstListQuery = true,
		listQueryProgress = false;

	// TODO: Add 'countries' property

	Object.defineProperty(this, 'list', {
		get: function() {
			if (firstListQuery && !listQueryProgress) {
				listQueryProgress = true;

				$http.get(Routing.generate(''))
					.then(function(response) {
						response.data.forEach(function(mountainData) {
							list.push(new Mountain(mountainData));
						});

						firstListQuery = false;
						listQueryProgress = false;
					})
					.catch(function(response) {
						listQueryProgress = false;
						$log.error(response);
					});
			}

			return list;
		}
	});

	this.new = function(mountainData) {
		return new Mountain(mountainData);
	};

	this.delete = function(mountain, callback) {
		return $http.delete(Routing.generate('api_entities_delete_mountain', {mountain: mountain.id}))
				.then(function() {
					mountain = null;

					if (typeof callback == 'function') {
						callback();
					}
				})
				.catch(function(response) {
					$log.error(response);
				});
	};

	this.restore = function(region, callback) {
		return $http.patch(Routing.generate('api_entities_patch_mountain', {id: region.id}))
				.then(function() {
					if (typeof callback == 'function') {
						callback();
					}
				})
				.catch(function(response) {
					$log.error(response);
				});
	};

	this.get = function(mountainId, callback) {
		var mountain = new Mountain({});

		$http.get(Routing.generate('api_entities_get_mountain', {mountain: mountainId}))
				.then(function(response) {
					mountain.update(response.data);

					if (typeof callback == 'function') {
						callback(mountain);
					}
				})
				.catch(function(response) {
					$log.error(response);
				});

		return mountain;
	};

	function Mountain(mountainData) {
		var peaks = [],
			firstPeaksQuery = true,
			peaksQueryProgress = false;

		angular.merge(this, mountainData);

		if (angular.isUndefined(this.mountain_peaks)) {
			Object.defineProperty(this, 'mountain_peaks', {
				enumerable: true,
				set: function(data) {
					data.forEach(function(area) {
						peaks.push(area);
					});
				},
				get: function() {
					if (firstPeaksQuery && !peaksQueryProgress && angular.isDefined(this.id)) {
						peaksQueryProgress = true;

						$http.get(Routing.generate('api_entities_get_mountain_peaks', {mountain: this.id}))
							.then(function(response) {
								// Мы еще не получили информации о районах
								if (peaks.length == 0) {
									response.data.forEach(function(peak) {
										peaks.push(peak);
									});
								}

								firstPeaksQuery = false;
								peaksQueryProgress = false;
							})
							.catch(function(response) {
								peaksQueryProgress = false;
								$log.error(response);
							});
					}

					return peaks;
				}
			});
		}

		Object.defineProperty(this, 'update', {
			enumerable: false,
			get: function() {
				return function(mountainData) {
					angular.merge(this, mountainData);
				}
			}
		});

		Object.defineProperty(this, 'save', {
			enumerable: false,
			get: function() {
				return function() {
					var method = this.id ? 'put' : 'post',
							url = this.id ?
									Routing.generate('api_entities_put_mountain', {mountain: this.id}) :
									Routing.generate('api_entities_post_mountain');

					var data = angular.merge({}, this);
					data.mountain_peaks = data.mountain_peaks.map(function(peak) {
							peak.mountainArea = peak.mountain_area.id;
							peak.mountain_area = undefined;
						return peak;
					});

					return $http[method](url, data);
				}
			}
		});
	}
});